import React from "react";

const Spinner = ({ className }) => (
  <div
    className={
      "d-flex spinner-container justify-content-center align-items-center " +
      className
    }
    role="status"
  >
    <span className="sr-only">Loading...</span>
    <div className="spinner-border" data-auto="spinner" />
  </div>
);

export default Spinner;
